import { render, staticRenderFns } from "./GenericContractProfileTab.vue?vue&type=template&id=eb73ebda&"
import script from "./GenericContractProfileTab.vue?vue&type=script&lang=ts&"
export * from "./GenericContractProfileTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports